/**
 * A plan lock replaces only the organization-flag hide. A menu switch, product
 * QA access, or group-manager gate still hides the row (MOT-794).
 */
export function isNavLeafVisible(
  leaf: {
    uiSwitch?: string;
    orgFlag?: string;
    requiresProductQa?: boolean;
    requiresGroupManager?: boolean;
  },
  answers: {
    uiSwitchOn: boolean;
    hasProductQa: boolean;
    managesGroup: boolean;
    lockName: string | null;
    orgFlagOn: boolean;
  },
): boolean {
  if (leaf.uiSwitch && !answers.uiSwitchOn) return false;
  if (leaf.requiresProductQa && !answers.hasProductQa) return false;
  if (leaf.requiresGroupManager && !answers.managesGroup) return false;
  if (answers.lockName != null) return true;
  if (leaf.orgFlag && !answers.orgFlagOn) return false;
  return true;
}
